// @ts-nocheck
import React, { useState } from 'react'
import { Col } from 'antd'
import { isEmpty } from 'lodash'
import {
  LocationBreakdown,
} from 'src/components/Modules/BreakdownFields'
import {
  ScreenshotsContainer
} from 'src/scenes/influencers/components/Fields/Screenshots'
import { StyledRow, StyledCol } from '..'

interface Props {
  formProps: any
}

const LocationSection = ({formProps}: Props) => {

  const [, setIsUploading] = useState(false)
  const [showExample, setShowExample] = useState({})
  const [, setScreenshotType] = useState('age')
  return(
    <StyledRow justify="space-between">
      <Col md={12} sm={24}><LocationBreakdown formProps={formProps} /></Col>
      <StyledCol md={12} sm={24}>
        <ScreenshotsContainer
          name="locationScreenshot"
          setIsUploading={loading => setIsUploading(loading)}
          setFieldValue={value =>
            formProps?.setFieldValue("locationScreenshot", value)
          }
          setFieldTouched={() =>
            formProps?.setFieldTouched("locationScreenshot", true)
          }
          values={formProps?.values}
          setShowExample={() =>
            setShowExample({
              location: true,
            })
          }
          setScreenshotType={() => setScreenshotType("location")}
          platformType={"Youtube"}
          accountName={""}
          screenshotType="location"
          multiple={false}
          disabled={!isEmpty(formProps?.values?.locationScreenshot)}
          showExample={showExample}
          hideExample={() =>
            setShowExample({
              location: false,
            })
          }
        />
      </StyledCol>
    </StyledRow>
  )
}

export default LocationSection
